import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const fuelfilterAuthorisedService = {
    getAllfuelfilterAuthoriseds,
    getfuelfilterAuthorised,
    updatefuelfilterAuthorised,
    createfuelfilterAuthorised,
    updatefuelfilterAuthorisedStatus
};

const MODULE = {
    AUTHORISED: 'fuel-filter-authoriseds',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllfuelfilterAuthoriseds(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.AUTHORISED}`, requestOptions)
  }

  export function getfuelfilterAuthorised(id) {   
    return apiHelper(API_URL).get(`/${MODULE.AUTHORISED}/${id}`)
  }

  export function updatefuelfilterAuthorised(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.AUTHORISED}/${data.id}`, requestOptions)
  }

  export function createfuelfilterAuthorised(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.AUTHORISED}`, requestOptions)
  }

  export function updatefuelfilterAuthorisedStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.AUTHORISED}/${data.id}`, requestOptions)
    
  }